<!-- single ion input, textarea, toggle -->
@if (field.type !== 'select' && field.type !== 'selectModal') {
  @if (field.inputType !== 'hidden' && !field.isHidden) {
    <ion-item mode="md" class="ion-activatable form-field-item form-field-item--{{field.inputType}}"
      [ngClass]="{ 'is-required': field.isRequired, 'is-read-only': field.isReadOnly }">
      @if (field.isNotPublic) {
        <ion-icon class="form-field-item__icon" name="eye-off-outline" color="dark" slot="start"/>
      }
      @if (field.inputType === 'date') {
        <ion-label>
          {{ field.label | translate }}

          @if (field.hintText) {
            <small class="date-hint-text">{{ field.hintText | translate }}</small>
          }
        </ion-label>
        <ion-datetime-button slot="end" [datetime]="dateTimeId">
          @if (!control.value) {
            <div class="date-placeholder" slot="date-target">{{ 'FORM.INPUT.DATE.PLACEHOLDER' | translate }}</div>
          }
        </ion-datetime-button>
        <ion-modal [keepContentsMounted]="true">
          <ng-template>
            <ion-datetime presentation="date" [id]="dateTimeId"
              [showDefaultButtons]="true"
              [doneText]="'BUTTON.CONFIRM' | translate"
              [cancelText]="'BUTTON.CANCEL' | translate"
              [formControl]="control"
              [formatOptions]="{ date: { day: '2-digit', month: '2-digit', year: 'numeric' } }"
              (ionChange)="onDateValueUpdated($event)"></ion-datetime>
          </ng-template>
        </ion-modal>
      }
      @else if (field.inputType === 'toggle') {
        <ion-toggle class="ion-focusable"
          (ionChange)="onToggleValueUpdated($event)"
          [helperText]="status === 'review-request' && field.hintText ? (field.hintText | translate) : null"
          [formControl]="control">
          {{ (field.label | translate) + (field.isRequired ? "*" : "") }}
        </ion-toggle>
      } @else if (field.inputType === 'textarea') {
        <ion-textarea auto-grow="true" [rows]="textareaRows"
          [tabIndex]="!field.isReadOnly ? 0 : -1"
          (ionInput)="onInputValueUpdated($event)"
          (ionBlur)="trimInputOnBlur($event)"
          [debounce]="inputDebounceTime"
          [formControl]="control"
          [placeholder]="(field.placeholder | translate) + (field.isRequired ? '*' : '')"
          [errorText]="(field.errorText || 'FORM.DEFAULT_ERROR_TEXT') | translate"
          [helperText]="status === 'review-request' && field.hintText ? (field.hintText | translate) : null"/>
      } @else {
        @if (field.inputType === 'number') {
          <!-- using static type="number" because dynamically bound type="number" inputs return string values instead of numbers -->
          <ion-input class="form-field-item__inner" type="number"
            [tabIndex]="!field.isReadOnly ? 0 : -1"
            (ionInput)="onInputValueUpdated($event)"
            (ionBlur)="trimInputOnBlur($event)"
            [debounce]="inputDebounceTime"
            [formControl]="control"
            [label]="(field.label | translate)"
            [placeholder]="field.placeholder | translate"
            [errorText]="(field.errorText || 'FORM.DEFAULT_ERROR_TEXT') | translate"
            [helperText]="status === 'review-request' && field.hintText ? (field.hintText | translate) : null"/>
        } @else if (field.inputType === 'file') {
          <ion-label class="file-upload-label">
            <span class="file-upload-label__inner" [innerHTML]="getFileName(control.value) || ('TERM.NO_FILE_SELECTED' | translate)"></span>
          </ion-label>
          <div class="form-field-upload" slot="end">
            @if (control.value) {
              <ion-button class="proto-button form-field-upload__remove-button"
                color="danger"
                size="small"
                fill="clear"
                slot="icon-only"
                shape="round"
                (confirm)="onRemoveFile()">
                <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
              </ion-button>
            }

            <div class="form-field-upload__button-container">
              <ion-button class="proto-button form-field-upload__button" color="medium">
                {{ field.label | translate }}
              </ion-button>
              <input #fileInput class="form-field-upload__input" type="file"
                [accept]="field.acceptedFileTypes"
                (change)="onFileSelected($event)" />
            </div>
          </div>
        } @else {
          <ion-input class="form-field-item__inner"
            [tabIndex]="!field.isReadOnly ? 0 : -1"
            (ionInput)="onInputValueUpdated($event)"
            (ionBlur)="trimInputOnBlur($event)"
            [debounce]="inputDebounceTime"
            [formControl]="control"
            [label]="(field.label | translate)"
            [placeholder]="field.placeholder | translate"
            [errorText]="(field.errorText || 'FORM.DEFAULT_ERROR_TEXT') | translate"
            [helperText]="status === 'review-request' && field.hintText ? (field.hintText | translate) : null"/>
        }
      }
    </ion-item>

    <!-- file gets extra handling for info text since ion-item has no according attribute;
      nested if clause for better readability; only show if no file is selected (customer request) -->
      @if (field.inputType === 'file' && !control.value) {
        @if (status === 'review-request' && field.hintText) {
        <!-- nested to indent the top border correctly -->
         <div class="form-field-external-hint">
           <div class="form-field-external-hint__text">
             {{ field.hintText | translate }}
           </div>
         </div>
       }
     }
  } @else {
    <input type="hidden" [formControl]="control"/>
  }
} @else if (field.type === 'selectModal') {
  @if (field.inputType !== 'hidden' && !field.isHidden) {
    <ion-item mode="md" [button]="!control.disabled" [disabled]="control.disabled"
      class="ion-activatable form-field-item form-field-item--select-modal"
      [ngClass]="{
        'is-required': field.isRequired,
        'is-read-only': field.isReadOnly,
        'has-value': control.value
      }"
      (click)="!control.disabled && openModal.emit({ field })">
      @if (field.isNotPublic) {
        <ion-icon class="form-field-item__icon" name="eye-off-outline" color="dark" slot="start"/>
      }
      <ion-input class="form-field-item__inner" readonly="true"
        tabindex="-1"
        (ionInput)="onInputValueUpdated($event)"
        [debounce]="inputDebounceTime"
        [formControl]="control"
        [placeholder]="field.placeholder | translate"
        [errorText]="(field.errorText || 'FORM.DEFAULT_ERROR_TEXT') | translate"
        [helperText]="status === 'review-request' && field.hintText ? (field.hintText | translate) : null">
        <ion-label class="select-modal-label" slot="start">
          <span class="ellipsis">{{ field.label | translate }}</span>
          <ion-icon class="link-icon" name="link-outline"></ion-icon>
        </ion-label>
        <ion-text slot="end">
          {{ getDisplayName(control.value) }}
        </ion-text>
        <ion-icon class="select-arrow-icon" slot="end" name="chevron-expand-outline"></ion-icon>
      </ion-input>
    </ion-item>
  } @else {
    <input type="hidden" [formControl]="control"/>
  }
} @else if (field.options?.length || isClassification) {
  <!-- select with single value or multiple values  -->
  @if (field.inputType !== 'checkboxOrRadio') {
    <ion-item mode="md" class="form-field-item form-field-item--select"
      [ngClass]="{ 'is-required': field.isRequired, 'is-read-only': !isClassification && field.options.length <= 1 }">
      @if (field.isNotPublic) {
        <ion-icon class="form-field-item__icon" name="eye-off-outline" color="dark" slot="start"/>
      }
      <ion-select toggleIcon="chevron-expand-outline" [interfaceOptions]="{ cssClass: 'form-field-select-alert form-field-select-alert--' + field.id }"
        [disabled]="isClassification && (optionsLoading || optionsError)"
        [multiple]="field.hasMultipleValues"
        [formControl]="control"
        [label]="field.label | translate"
        [placeholder]="field.placeholder | translate"
        [helperText]="status === 'review-request' && field.hintText ? (field.hintText | translate) : null"
        (ionChange)="onSelectValueUpdated($event)">
        @if (control.value && !field.hasMultipleValues && !field.isRequired) {
          <ion-select-option class="select-interface-option--reset" value="">
            {{ 'TERM.SELECT_RESET' | translate }}
          </ion-select-option>
        }

        @for (option of field.options; track option.id) {
          <ion-select-option
            [className]="'select-interface-option--' + option.value"
            [disabled]="option.disabled"
            [value]="option.value">
            {{ option.label | translate }}
          </ion-select-option>
        }
      </ion-select>
    </ion-item>
  } @else {
    <!-- radio group (!hasMultipleValues) or checkbox group (hasMultipleValues) -->
  <small class="data-review-changed-info">{{ 'FORM.COMMON.INPUT_CHANGED' | translate }}</small>

    @if (field.hasMultipleValues) {
      @for (option of field.options; track option.id) {
        <ion-item mode="md" class="form-field-item form-field-item--checkbox checkbox-group-item">
          @if (field.isNotPublic) {
            <ion-icon class="form-field-item__icon" name="eye-off-outline" color="dark" slot="start"/>
          }
          <ion-checkbox [checked]="multipleCheckboxIsChecked(option.value)" label-placement="end"
            (ionChange)="onCheckboxValueUpdated($event, option.value)">
            {{ option.label | translate }}
          </ion-checkbox>
        </ion-item>
      }
    } @else {
      <ion-radio-group [allowEmptySelection]="!field.isRequired" mode="md" class="form-field-item form-field-item--radio" [formControl]="control">
        @for (option of field.options; track option.id) {
          <ion-radio labelPlacement="end" [value]="option.value">{{ option.label | translate }}</ion-radio>
        }
      </ion-radio-group>
    }
  }
}

@if (isClassification && optionsLoading) {
  <ion-note>{{ 'FORM.CLASSIFICATION_OPTIONS.LOADING' | translate }}</ion-note>
}
@if (isClassification && optionsError) {
  <div role="alert">{{ 'FORM.CLASSIFICATION_OPTIONS.LOAD_FAILED' | translate }}
    <ion-button fill="clear" (click)="loadClassificationOptions()">{{ 'BUTTON.RELOAD' | translate }}</ion-button>
  </div>
}
